export default "__VITE_ASSET__BrrpPC0y__"